<template>
  <v-main>
    <v-container>
      <v-layout column text-center wrap align-content-center justify-center>
        <v-card width="640">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Set Domain</v-toolbar-title>
          </v-toolbar>
          <v-alert v-model="showSuccess" type="success" text class="text-left">
            Domain has been set to
            <v-chip label text light>{{ domain }}</v-chip>
          </v-alert>
          <v-card-text class="pt-4">
            <v-form>
              <v-text-field
                v-model="v$.domain.$model"
                label="Customer domain"
                :error-messages="errors"
                filled
                :disabled="!isDev"
              />
              <v-layout justify-space-between>
                <v-spacer></v-spacer>
                <v-btn
                  type="submit"
                  color="primary"
                  :disabled="v$.$invalid || !isDev || !v$.$anyDirty"
                  @click.prevent="confirm()"
                >
                  Set domain
                </v-btn>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { minLength, required, helpers } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      showSuccess: false,
      domain: false,
      isDomain: (val) =>
        /^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.connexionz\.net$/gi.test(
          val
        ),
    };
  },
  computed: {
    isDev() {
      return this.$store.state.isDev;
    },
    errors() {
      return this.v$.$errors.map((e) => e.$message);
    },
  },
  mounted() {
    this.domain = this.$store.state.domain ?? "localhost";
  },
  validations() {
    return {
      domain: {
        required,
        domain: helpers.withMessage("Invalid domain", this.isDomain),
        minLength: minLength(8),
      },
    };
  },
  methods: {
    confirm() {
      this.$store.commit("setDomain", this.domain);
      this.showSuccess = true;
      this.v$.$reset();
    },
  },
};
</script>
